import { useSelector } from "react-redux";
import { getSpinURL } from "../../redux/selectors";
import { MainScreenAppBar as MainScreenAppBarPure } from "./MainScreenAppBar";

export default function MainScreenAppBar(props) {
  const { id, className } = props;
  const spinURL = useSelector(getSpinURL);
  return (
    <MainScreenAppBarPure className={className} id={id} spinURL={spinURL} />
  );
}
